import { Injectable } from '@angular/core';
import {
  addListener,
  isLaunch,
  launch,
  removeListener,
  stop,
} from 'devtools-detector';

import { environment } from '@fantaz/shared/app-config';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DevToolDetectionService {
  devToolIsOpen$ = new Subject<boolean>();

  startDevtoolDetector() {
    if (environment.devToolDetection) {
      // 1. add listener
      addListener((isOpen: boolean) => {
        this.devToolIsOpen$.next(isOpen);
      });
      // 2. launch detect
      launch();
    } else {
      this.devToolIsOpen$.next(false);
    }
  }
  stopDevtoolDetector() {
    if (environment.devToolDetection && isLaunch()) {
      // 1. remove listener
      removeListener((isOpen: boolean) => {
        this.devToolIsOpen$.next(isOpen);
      });
      // 2. stop devtool detector
      stop();
    }
    this.devToolIsOpen$.next(false);
  }
}
